define('OrderWizard.Module.Shipmethod.Extension', [
  'OrderWizard.Module.Shipmethod',
  'initWestSelectShipping',
  'underscore'
], function(
  OrderWizardModuleShipmethod,
  initWestSelectShipping,
  _
) {
  'use strict';

  return _.extend(OrderWizardModuleShipmethod.prototype, {

    initialize: _.wrap(OrderWizardModuleShipmethod.prototype.initialize, function(fn) {
      try {
        fn.apply(this, _.toArray(arguments).slice(1));
        initWestSelectShipping(this);
      } catch(err) { console.error(162038, err); }
    }),

    shipAddressChange: _.wrap(OrderWizardModuleShipmethod.prototype.shipAddressChange, function(fn) {
      try {
        fn.apply(this, _.toArray(arguments).slice(1));
        this.reloadMethodsPromise.then(function () {
          initWestSelectShipping(this);
        });
      } catch (err) {
        console.error(502953, err);
      }
    })

  });
});
